// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_69f2db6c7f--wrapper--TyfcI","wrapper-phone":"_69f2db6c7f--wrapper-phone--oyO0_","title":"_69f2db6c7f--title--PRHoo","list":"_69f2db6c7f--list--l6eET"};